import React from 'react';
import Icon from '../../../components/AppIcon';

const CommissionBreakdown = ({ breakdown }) => {
  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-6"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-4 md:mb-6">
        Commissie Overzicht
      </h3>
      <div className="space-y-4">
        {breakdown?.map((item, index) => (
          <div key={index} className="flex items-center justify-between pb-4 border-b border-border last:border-0 last:pb-0">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className={`w-10 h-10 ${item?.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                <Icon name={item?.icon} size={18} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm md:text-base text-foreground mb-1">{item?.label}</p>
                <p className="caption text-muted-foreground">{item?.count} referrals</p>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <p className="font-semibold text-base md:text-lg text-foreground">€{item?.amount?.toLocaleString('nl-NL')}</p>
              <p className="caption text-muted-foreground">{item?.percentage}%</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="font-heading font-semibold text-base md:text-lg text-foreground">Totaal Commissie</span>
          <span className="font-heading font-bold text-xl md:text-2xl text-success">
            €{breakdown?.reduce((sum, item) => sum + item?.amount, 0)?.toLocaleString('nl-NL')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CommissionBreakdown;